module.exports = __webpack_public_path__ + "static/media/doc2.fc7fe14a.jpg";